module.exports = __webpack_public_path__ + "img/headset-white.7d93f6af.svg";